<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon
        small
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to delete this basic salary? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"      
          class="px-10 white--text"       
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      basicSalary: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: false,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true
              
        this.$api.companyEmployeeSalaries().delete(this.basicSalary.id)
          .then(response => {
            this.$snack({ message: response.data.status })
            this.$emit('deleted')
          })
          .catch(error => {
            this.$snack({ 
              color: 'error',
              message: error.response.data.message, 
            })
          })
          .then(() => {
            this.menu = false
            this.progressing = false
          })    
      },
    },
  }
</script>
